"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodPriceV2 = exports.PeriodPrice = exports.UnitQuantityV2 = exports.UnitQuantity = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../../decorators");
class UnitQuantity extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumberString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'yearly Quantity', example: '800' }),
    tslib_1.__metadata("design:type", String)
], UnitQuantity.prototype, "yearlyQuantity", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'unit of yearly Quantity', example: 'kWh' }),
    tslib_1.__metadata("design:type", String)
], UnitQuantity.prototype, "unitOfMeasurement", void 0);
exports.UnitQuantity = UnitQuantity;
class UnitQuantityV2 extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumberString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'period Quantity', example: '800' }),
    tslib_1.__metadata("design:type", String)
], UnitQuantityV2.prototype, "periodQuantity", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'unit of period Quantity', example: 'kWh' }),
    tslib_1.__metadata("design:type", String)
], UnitQuantityV2.prototype, "unitOfMeasurement", void 0);
exports.UnitQuantityV2 = UnitQuantityV2;
class PeriodPrice extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, apigw_models_1.Docs)({ description: 'Description', example: 'Variabele leveringskosten Normaaltarief' }),
    tslib_1.__metadata("design:type", String)
], PeriodPrice.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Price of one unit', example: 0.22981 }),
    tslib_1.__metadata("design:type", Number)
], PeriodPrice.prototype, "unitPrice", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Monthly amount', example: 200 }),
    tslib_1.__metadata("design:type", Number)
], PeriodPrice.prototype, "monthlyAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Yearly amount', example: 2400 }),
    tslib_1.__metadata("design:type", Number)
], PeriodPrice.prototype, "yearlyAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the consumption', example: '/kWh' }),
    tslib_1.__metadata("design:type", String)
], PeriodPrice.prototype, "unitOfMeasurement", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the cost amount', example: '€' }),
    tslib_1.__metadata("design:type", String)
], PeriodPrice.prototype, "unitOfMeasurementAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => UnitQuantity),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", UnitQuantity)
], PeriodPrice.prototype, "unitQuantity", void 0);
exports.PeriodPrice = PeriodPrice;
class PeriodPriceV2 extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, apigw_models_1.Docs)({ description: 'Description', example: 'Variabele leveringskosten Normaaltarief' }),
    tslib_1.__metadata("design:type", String)
], PeriodPriceV2.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Price of one unit', example: 0.22981 }),
    tslib_1.__metadata("design:type", Number)
], PeriodPriceV2.prototype, "unitPrice", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Period amount', example: 2400 }),
    tslib_1.__metadata("design:type", Number)
], PeriodPriceV2.prototype, "periodAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({
        description: 'Start date for the period of this price record (format dd-MM)',
        example: '21-04',
    }),
    tslib_1.__metadata("design:type", String)
], PeriodPriceV2.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({
        description: 'End date for the period of this price record (format dd-MM)',
        example: '20-04',
    }),
    tslib_1.__metadata("design:type", String)
], PeriodPriceV2.prototype, "toDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the consumption', example: '/kWh' }),
    tslib_1.__metadata("design:type", String)
], PeriodPriceV2.prototype, "unitOfMeasurement", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the cost amount', example: '€' }),
    tslib_1.__metadata("design:type", String)
], PeriodPriceV2.prototype, "unitOfMeasurementAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => UnitQuantityV2),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", UnitQuantityV2)
], PeriodPriceV2.prototype, "unitQuantity", void 0);
exports.PeriodPriceV2 = PeriodPriceV2;
